export function Card({ children, onClick }) {
    return (
      <div
        onClick={onClick}
        className="property-card"
      >
        {children}
      </div>
    );
  }
  
  export function CardContent({ children }) {
    return <div className="property-details">{children}</div>;
  }